import styled from 'styled-components';
import { colors } from '../../styles/constants';

const StyledContextDate = styled.div`
  color: ${colors.purple};
`;

export default StyledContextDate;
